import { render, staticRenderFns } from "./CGV.vue?vue&type=template&id=6f9f9064&scoped=true"
import script from "./CGV.vue?vue&type=script&lang=js"
export * from "./CGV.vue?vue&type=script&lang=js"
import style0 from "./CGV.vue?vue&type=style&index=0&id=6f9f9064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f9064",
  null
  
)

export default component.exports